<template>

  <div class="form-check">
    <label class="form-check-label" >
      Keine Vorlesung dieses Semester
    </label>
  </div>
  
</template>

<script>

export default {
  name: "navEntryEmpty"
}
</script>

